// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"67218c77","498":"fa5905c2","596":"74900566","703":"9fdfb585"}[chunkId] + ".chunk.js";
};